import { ConnectMetaMask } from ".";
import { ReactNode, useContext } from "react";
import { AppContext } from "../../AppContext";

interface Props {
  children: ReactNode;
  connectBtnText?: string;
}

export function RequireMetaMask({ children, connectBtnText }: Props) {
  const ctx = useContext(AppContext);

  if (ctx.accounts) {
    return children;
  } else {
    return <ConnectMetaMask connectBtnText={connectBtnText} />;
  }
}
